import { AppStandardButton } from "../../UI/AppButtons";
import React from "react";
import { useTranslation } from "react-i18next";
import i18n, { t } from "i18next";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import BookingApi from "../../../API/Apis/BookingApi";
import BookingGetters from "../../../store/onlineBooking/getters";

export function SuccessPage() {
  const language = i18n.language;
  const { t: translate } = useTranslation();
  const location = useLocation();
  const appSettings = BookingGetters?.getAppSettings();
  const sendConfirmationEmailAfterWebCheckin =
    appSettings?.sendConfirmationEmailAfterWebCheckin;
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("reservationId");
  useEffect(() => {
    const parsedReservationId = parseInt(id || "");

    if (sendConfirmationEmailAfterWebCheckin && language) {
      BookingApi.sendEmailForWireTransfer(
        parsedReservationId,
        "webCheckinEmail",
        language
      )
        .then(() => {
          // console.log("Email sent successfully");
        })
        .catch((err) => {
          console.error("Failed to send email:", err);
        });
    }

    BookingApi.webCheckinConfirmation(
      parsedReservationId,
      "webCheckinConfirmation",
      language
    )
      .then(() => {})
      .catch((err) => {
        console.error("Error", err);
      });
  }, [id, language, sendConfirmationEmailAfterWebCheckin]);
  const isSmallScreen = window.innerWidth <= 500;
  return (
    <section
      className={`min-h-[80vh] box-border md:px-44  flex flex-col border-t-2 border-solid border-grey-300 ${
        isSmallScreen ? "px-4" : "px-10"
      } `}
    >
      <header className="grow flex flex-col items-center justif-center gap-4 box-border py-8">
        <img
          src="/assets/images/success-icon@2x.png"
          className={`${isSmallScreen ? "h-28 w-28" : "h-36 w-36"} `}
        />
        {/*<h1 className="text-3xl font-bold text-[#004188] py-2">*/}
        <h1
          className={`font-bold text-[#004188] py-2 ${
            isSmallScreen ? "text-2xl" : "text-3xl"
          } `}
        >
          {t("Congratulations! Your Web Check-In Is Completed")}
        </h1>
        <p className="font-bold text-black-600"></p>
        <AppStandardButton
          href={`/booking/web-check-in?lang=${i18n.language}`}
          className={"w-fit py-4 "}
          color="primary"
          style={{ borderRadius: "5" }}
        >
          {/* Go to Account */}
          <span className="normal-case p-1 text-lg" style={{ color: "white" }}>
            {" "}
            Homepage
          </span>
        </AppStandardButton>
      </header>
      <main></main>
      <footer className="text-gray-600 box-border pb-32">
        {/* Web Checkin Info */}
        {/* Web Checkin Information */}

        <div className="box-border border-2 border-solid border-grey-200 px-8"></div>
      </footer>
    </section>
  );
}
// export { WebCheckinConfirmation };
